export default import.meta.ROLLDOWN_FILE_URL_Cq3CqsxqGE4RJZmEgM9M$g